import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import HowItWorksSection from './components/HowItWorksSection';
import FeaturesSection from './components/FeaturesSection';
import PackagesSection from './components/PackagesSection';
import DemoPackagesSection from './components/DemoPackagesSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import StatementAndCTA from './components/StatementAndCTA';
import WhatsAppButton from './components/WhatsAppButton';
import LogosBand from './components/LogosBand';
import { WhatsAppLeadProvider } from '@/hooks/useWhatsAppLead';
import WhatsAppLeadModal from '@/components/feature/WhatsAppLeadModal';
import { TrackingProvider } from '@/hooks/useTracking';

export default function HomePage() {
  return (
    <WhatsAppLeadProvider>
      <TrackingProvider>
        <div className="min-h-screen bg-dark text-white">
          <Header />
          <main>
            <div id="section-hero"><HeroSection /></div>
            <LogosBand />
            <div id="section-problem"><ProblemSection /></div>
            <div id="section-solution"><SolutionSection /></div>
            <div id="section-how"><HowItWorksSection /></div>
            <div id="section-features"><FeaturesSection /></div>
            <div id="section-packages"><PackagesSection /></div>
            <DemoPackagesSection />
            <div id="section-testimonials"><TestimonialsSection /></div>
            <div id="section-faq"><FAQSection /></div>
            <div id="section-cta"><StatementAndCTA /></div>
          </main>
          <WhatsAppButton />
          <WhatsAppLeadModal />
        </div>
      </TrackingProvider>
    </WhatsAppLeadProvider>
  );
}
